import Button from "../Input/Button";
import ManageAccountPageWrapper from "../Layout/ManageAccountPageWrapper";

import * as Icon from "react-bootstrap-icons";
import { Link } from "react-router-dom";
import dig from "../../../assets/images/dig.jpg"

function ContactSection({
  icon,
  headerText,
  mainText,
  subText,
  textRow = null,
}) {
  return (
    <div className="contact-section">
      <div className="contact-section-wrapper">
        <div className="contact-section-header">
          {icon}
          <p className="display-4">{headerText}</p>
        </div>

        {textRow === null ? (
          <div className="contact-section-info">
            <p className="font-weight-bold">{mainText}</p>
            <p>{subText && subText}</p>
          </div>
        ) : (
          <div className="contact-section-info-row">
            <div className="contact-section-info">
              <p>{textRow?.mainText1}</p>
              <p className="font-weight-bold">{textRow?.subText1}</p>
            </div>
            <div className="contact-section-info">
              <p>{textRow?.mainText2}</p>
              <p className="font-weight-bold">{textRow?.subText2}</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default function ContactPage() {
    
  let userRole = localStorage.getItem("userRole");
    
  return (
    <ManageAccountPageWrapper
      pageName="Contact"
      button={
        <Link
          to={{
            pathname:
              "https://octanecdn.com/firesidenaturalgascom/firesidenaturalgascom_911400144.pdf",
          }}
          target="_blank">
          { userRole !== "IT-User" && (
          <Button
            className="btn btn--green btn--bordered"
            text="Explanation of Bill"
          />
          )}  
        </Link>
      }>
      <div className="contact-row">
        <ContactSection
          icon={<Icon.GeoAlt color="#67BD45" />}
          headerText="Address"
          mainText="900 Circle 75 Pkwy, Ste 200"
          subText="Atlanta, GA 30339"
        />
        <ContactSection
          icon={<Icon.Clock color="#67BD45" />}
          headerText="Office Hours"
          mainText="8am - 5pm"
          subText="Mon - Fri"
        />
      </div>
      <div className="contact-row">
        <ContactSection
          icon={<Icon.Telephone color="#67BD45" />}
          headerText="Call Us"
          mainText={
              <a href="tel:PHONE_NUM"> (678) 872-0250 </a>
          }
        />
        <ContactSection
          icon={<Icon.Envelope color="#67BD45" />}
          headerText="Email Us"
          mainText={
            <a href="mailto:NaturalGasGA.SharedMailbox@nexteraenergy.com">
                NaturalGasGA.SharedMailbox@nexteraenergy.com
            </a>
          }
        />
      </div>
      <div className="contact-row">
        <div className="contact-section--red">
            <div className="contact-section-wrapper">
                <div className="contact-section-header--col">
                    <Icon.ExclamationTriangle
                        color="#f32d2d"
                        height={32}
                        width={32}
                    />
                    <h3>Gas Leaks and Emergencies</h3>
                </div>
                <div className="contact-gasleak">
                    <p>Call Atlanta Gas Light&nbsp;</p>
                    <h4>
                        <a href="tel:PHONE_NUM"> (877) 427-4321 </a>
                    </h4>
                </div>
            </div>
        </div>
        <div className="contact-section">
          <div className="contact-section-wrapper">
              <div >
                  <a href="https://www.georgia811.com" target="_blank">
                      <img
                          className="before-dig"
                          alt="Before You Dig"
                          src={dig}
                      />
                  </a>
              </div>
              <div className="contact-dig">
                  <h4>
                      <a href="tel:PHONE_NUM"> (800) 282-7411 </a>
                  </h4>
              </div>
          </div>
        </div>
      </div>
    </ManageAccountPageWrapper>
  );
}
